// Gaudi comes first so client overrides work correctly
import '@economic/gaudi/dist/index.css';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Loader from './app/shared/components/Loader';

const Economic = React.lazy(() => import(/* webpackChunkName: "application" */ './app'));
const External = React.lazy(() => import(/* webpackChunkName: "external" */ './external'));

const Application = () => {
    return (
        <React.Suspense fallback={<Loader />}>
            <BrowserRouter>
                <Switch>
                    <Route path="/external" component={External} />
                    <Route component={Economic} />
                </Switch>
            </BrowserRouter>
        </React.Suspense>
    );
};

ReactDOM.render(<Application />, document.getElementById('root'));
